/* global axios */
import ApiClient from './ApiClient';

// Converter recursivamente um objeto em FormData. Arrays viram
// `key[]=v1&key[]=v2`, objetos aninhados viram `key[subkey]=value`.
// null vira string vazia; File é appended diretamente.
function objectToFormData(obj) {
  const fd = new FormData();
  const append = (key, value) => {
    if (value === undefined) return;
    if (value === null) {
      fd.append(key, '');
    } else if (value instanceof File) {
      fd.append(key, value);
    } else if (Array.isArray(value)) {
      value.forEach(v => fd.append(`${key}[]`, v == null ? '' : v));
    } else if (typeof value === 'object') {
      Object.entries(value).forEach(([k, v]) => append(`${key}[${k}]`, v));
    } else {
      fd.append(key, String(value));
    }
  };
  Object.entries(obj).forEach(([k, v]) => append(k, v));
  return fd;
}

class ProfessionalsAPI extends ApiClient {
  constructor() {
    super('professionals', { accountScoped: true });
  }

  availability(id, { date, serviceId }) {
    return axios.get(`${this.url}/${id}/availability`, {
      params: { date, service_id: serviceId },
    });
  }

  // Detect File em data.avatar e usa FormData (multipart/form-data)
  // para upload de imagem; caso contrário envia JSON normal.
  // Mantém a compatibilidade com o ApiClient herdado.
  create(data) {
    if (data && data.avatar instanceof File) {
      return axios.post(this.url, this.toFormData(data), {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
    }
    return super.create(data);
  }

  update(id, data) {
    if (data && data.avatar instanceof File) {
      return axios.patch(`${this.url}/${id}`, this.toFormData(data), {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
    }
    return super.update(id, data);
  }

  static toFormData(obj) {
    return objectToFormData(obj);
  }
}

export default new ProfessionalsAPI();
